import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PageInfo {
    path: string;
    name: string;
}

interface NavigationState {
    history: PageInfo[];
}

const initialState: NavigationState = {
    history: [],
};

const navigationSlice = createSlice({
    name: 'navigation',
    initialState,
    reducers: {
        pushPage: (state, action: PayloadAction<PageInfo>) => {
            const last = state.history[state.history.length - 1];
            if (!last || last.path !== action.payload.path) {
                state.history.push(action.payload);
            }
        },
        popPage: (state) => {
            state.history.pop();
        },
        resetHistory: (state) => {
            state.history = [];
        },
    },
});

export const { pushPage, popPage, resetHistory } = navigationSlice.actions;
export default navigationSlice.reducer;
